module.exports = __webpack_public_path__ + "img/hand_with_bag_of_dollars.971af428.svg";